enum TrialHistoryStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  DOCUMENTATION_REQUEST = 'DOCUMENTATION_REQUEST',
  DOCUMENTATION_PROVIDED = 'DOCUMENTATION_PROVIDED',
  TO_CHECK = 'TO_CHECK',
  IN_CONFERENCE = 'IN_CONFERENCE',
  CHECKED = 'CHECKED',
  WITHDRAWAL = 'WITHDRAWAL',
  SENT = 'SENT',
  UPDATE = 'UPDATE',
}

export default TrialHistoryStatus;
